import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Button } from 'react-bootstrap';
import AnimateHeight from 'react-animate-height';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { deleterDispatchHelper } from 'actions/DeleterActions';
import { addNotification } from 'actions/NotificationsActions';

import List from 'components/List';

import Loader from 'components/layout/Loader';
import SimplePrompt from 'components/layout/SimplePrompt';
import TableResponsive from 'components/layout/TableResponsive';
import ClientListInfo from 'components/layout/ClientListInfo';

import FormAutocomplete from 'components/forms/FormAutocomplete';

class TeamMembers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
    };
  }

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      formStatus,
      deleterStatus,
      doNotify,
    } = this.props;

    if (!formStatus.pending && !formStatus.hasError && prevProps.formStatus.pending) {
      doNotify(1, messages.team_member_added);
    }

    if (!deleterStatus.pending && !deleterStatus.hasError && prevProps.deleterStatus.pending) {
      doNotify(1, messages.team_member_removed);
    }
  };

  show = () => {
    this.setState({ show: true });
  };

  addUser = (formPropertyName, user) => {
    if (user) {
      const { teamId, addToTeam } = this.props;
      addToTeam(teamId, user.username);
    }

    this.setState({ show: false });
  };

  handleRemoveClick = (e, username) => {
    e.preventDefault();
    e.stopPropagation();

    const { teamId, removeFromTeam } = this.props;
    removeFromTeam(teamId, username);
  };

  render() {
    const {
      intl: { messages },
      list,
      teamId,
    } = this.props;
    const { show } = this.state;

    const urlData = {
      filters: {
        type: 'employee',
        teams: teamId,
      },
    };

    const headers = {
      user: messages.user,
      actions: messages.actions,
    };
    const rows = [];
    for (let i = 0; i < list.data.list.length; i++) {
      const rowData = {
        client: <ClientListInfo client={list.data.list[i]} />,
        actions: [
          <SimplePrompt
            key="remove"
            iconClass="fal fa-user-times"
            buttonLabel={messages.remove_selection}
            onSuccess={e => this.handleRemoveClick(e, list.data.list[i].username)}
          />,
        ],
      };

      rows.push(rowData);
    }

    return (
      <div className="clearfix padding-15">
        <AnimateHeight duration={500} height={show ? 'auto' : 0}>
          <div className="form-group-attached">
            <FormAutocomplete
              label={messages.add_team_member}
              name="user"
              onChange={this.addUser}
              returnValueObject
              autocompleteType="user"
              urlFilters={{
                filters: {
                  teams: '!' + teamId,
                },
              }}
            />
          </div>
        </AnimateHeight>
        <AnimateHeight duration={500} height={!show ? 'auto' : 0}>
          <div className="text-center">
            <Button className="btn-rounded" onClick={this.show}>
              <i className="fa fa-plus" />
            </Button>
          </div>
        </AnimateHeight>

        <List
          listName="teamMembers"
          url="/api/clients.json"
          urlData={urlData}
          list={list}
          sortOptions={['relevance,desc']}
          showSearch={false}
        >
          {list.pending ? <Loader /> : <TableResponsive headers={headers} rows={rows} hover />}
        </List>
      </div>
    );
  }
}
TeamMembers.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    list: state.list.teamMembers,
    formStatus: state.formStatus.addUserToTeam,
    deleterStatus: state.deleter.removeUserFromTeam,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    addToTeam: (teamId, username) => {
      formStatusDispatchHelper(
        'addUserToTeam',
        `/api/teams/${teamId}/users/${username}/add.json`,
        {},
        'post',
        dispatch
      );
    },
    removeFromTeam: (teamId, username) => {
      deleterDispatchHelper('removeUserFromTeam', `/api/teams/${teamId}/users/${username}/remove.json`, dispatch);
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TeamMembers)
);
